import { LeasingType } from 'modules/types/LeasingOffer';
import { LeasingInstallmentState } from './LeasingInstallmentState';

type FutureValuePercentageMapType = {
  [id: number]: number;
};
export const OperationalFutureValuePercentageMap: FutureValuePercentageMapType =
  {
    1: 67,
    2: 53,
    3: 41,
    4: 35,
    5: 31,
    6: 26,
    7: 22,
  };

export const PaymentPeriodMap: { [name: string]: number } = {
  Mjesečno: 12,
  Kvartalno: 4,
  Polugodišnje: 2,
  Godišnje: 1,
};

export const DEFAULT_PAYMENTS_PER_YEAR = 12;

export const PDV = 1.25;
const minInterestRate = 0.000000001;

export const calculatedLeasingInstallment = (
  netPrice: string,
  ppmv: string,
  financingPeriodInYears: number | string,
  interestRatePercentage: number,
  participationPercantage?: string,
  leasingType?: string,
  futureValuePercentage?: number,
  paymentsPerYear: number = DEFAULT_PAYMENTS_PER_YEAR,
): LeasingInstallmentState<number> => {
  const totalPayments = +financingPeriodInYears * paymentsPerYear;

  let interestRate = interestRatePercentage / 100;
  if (interestRate === 0) {
    interestRate = minInterestRate;
  }

  // operational leasing
  let price = +netPrice;
  const futureValueDecimal = (futureValuePercentage ?? 0) / 100;

  // financial leasing
  if (leasingType === LeasingType.FINANCIAL) {
    price = getBrutoPrice(netPrice);
  }

  const participationAmount = getParticipationAmount(
    price,
    ppmv,
    participationPercantage,
  );

  const Pv = price + +ppmv - participationAmount;
  const Fv = (price + +ppmv) * futureValueDecimal;
  const ratePerPeriod = interestRate / paymentsPerYear;
  const C = Math.pow(1 + ratePerPeriod, totalPayments);

  // installment value per period
  const installmentValue = ((Pv * C - Fv) * ratePerPeriod) / (C - 1);

  return {
    leasingInstallment: installmentValue,
    leasingParticipationAmount: participationAmount,
    futureValuePercentage: futureValueDecimal * 100,
    futureValue: Fv,
  };
};

export const getBrutoPrice = (netPrice: string | number) => +netPrice * PDV;

export const getParticipationAmount = (
  price: number,
  ppmv: string,
  participationPercantage: string | undefined,
) => (price + +ppmv) * (+(participationPercantage || 0) / 100);
